var vcTourFeatures = function (element) {
  if (element) {
    uiBindings();
  }

  function uiBindings() {
    var links = element.querySelectorAll(".tour-feature-link");
    // links.firstElementChild.parentElement.classList.add("active");
    if (links) {
      for (var i = 0; i < links.length; i++) {
        links[i].addEventListener("mouseover", function (evt) {
          var changeImage = canChangeImage(evt);
          if (changeImage) {
            evt.stopPropagation();
            evt.preventDefault();
            elem = this;
            showImage(elem);
            // setActiveState(elem);
            return false;
          }
        });
      }
    }
  }
  function canChangeImage(evt) {
    var can = true;
    var featureImg = element.querySelector(".first-col");
    if (evt.target.classList.contains("external-link")) {
      can = false;
    } else if (featureImg.firstElementChild.style.display == "none") {
      can = false;
    }
    return can;
  }

  function showImage(elem) {
    var targetImage = elem.getAttribute("data-target-img");
    var imageObject = document.querySelectorAll(".tour-feature-image img");
    if (imageObject && targetImage) {
      for (var i = 0; i < imageObject.length; i++) {
        imageObject[i].classList.remove("active");
        document
          .querySelector("[data-img-id='" + targetImage + "']")
          .classList.add("active");
      }
    }
  }

  function setActiveState(elem) {
    var tourItemContainer = document.querySelectorAll(
      ".tour-feature-item-container"
    );
    if (tourItemContainer) {
      for (var i = 0; i < tourItemContainer.length; i++) {
        tourItemContainer[i].classList.remove("active");
        elem.parentElement.classList.add("active");
      }
    }
  }
};